import * as yup from "yup";

const useFoldersStructureChildFolderSchema = () => yup.object({
    selectableFolderName: yup.string(),
    textFolderName: yup.string(),
});

export default useFoldersStructureChildFolderSchema;
